<template>
  <div style="overflow: hidden">
    <!-- 顶部背景和搜索框 -->
    <div class="header" :style="{ paddingBottom: promotionList.length > 0 ? '105px' : '5px' }">
      <div class="search-box" @click="$router.push('/search')">
        <img class="search-icon" src="@/assets/img/mobile-img/search-icon.png" alt="" />
        <span>搜索</span>
      </div>
    </div>
    <!-- 推广轮播图 -->
    <div class="promotion-swipe" v-if="promotionList.length > 0">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="item in promotionList" :key="item.id" @click="toPromotion(item)">
          <img :src="`${$global.imgUrl}${item.img}`" style="width: 100%; height: 100%" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 栏目盒子 -->
    <ul class="column-box">
      <li @click="serve(0)">
        <img src="@/assets/img/mobile-img/column/contribute-icon.png" alt="" />
        <p>选刊投稿</p>
      </li>
      <li @click="serve(1)">
        <img src="@/assets/img/mobile-img/column/progress-icon.png" alt="" />
        <p>稿件进度</p>
      </li>
      <li @click="serve(4)">
        <img src="@/assets/img/mobile-img/column/book-mall-cion.png" alt="" />
        <p>图书商城</p>
      </li>
      <li @click="serve(2)">
        <img src="@/assets/img/mobile-img/column/Sign-icon.png" alt="" />
        <p>学术会议</p>
      </li>
      <li @click="serve(8)">
        <img src="@/assets/img/mobile-img/column/monograph-publication.png" alt="" />
        <p>专著出版</p>
      </li>
      <li @click="serve(9)">
        <img src="@/assets/img/mobile-img/column/industry-report.png" alt="" />
        <p>行业报告</p>
      </li>
      <li @click="serve(6)">
        <img src="@/assets/img/mobile-img/column/baike-icon.png" alt="" />
        <p>百科在线</p>
      </li>
      <li @click="serve(5)">
        <img src="@/assets/img/mobile-img/column/baijia-icon.png" alt="" />
        <p>百家在线</p>
      </li>
      <li @click="serve(3)">
        <img src="@/assets/img/mobile-img/column/education-icon.png" alt="" />
        <p>教育培训</p>
      </li>
      <li @click="serve(7)">
        <img src="@/assets/img/mobile-img/column/extend-icon.png" alt="" />
        <p>推广市场</p>
      </li>
    </ul>
  </div>
</template>

<script>
var vm;

import { Swipe, SwipeItem } from "vant";
export default {
  name: "homeHeader",
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
  },
  data() {
    return {
      promotionList: [],
    };
  },

  created() {
    vm = this;
    this.getPromotion();
  },
  methods: {
    // 推广Banner列表
    async getPromotion() {
      let resp = await this.$apis.mainServe.getPromotion();
      if (resp.resultCode == 200) {
        this.promotionList = resp.data;
      }
    },
    // 推广Banner进入详情
    async toPromotion(item) {
      if (item.type == 0) {
        window.location.href = item.jsonObject.link;
      } else {
        let resp = await this.$apis.mainServe.getWXScheme({ id: item.id });
        if (resp.resultCode == 200) {
          // location.href = resp.data + `&path=${item.jsonObject.path}`
          location.href = resp.data;
        }
      }
    },
    // 栏目点击进入
    serve(key) {
      switch (key) {
        case 0: // 选刊投稿
          this.$router.push("/manuscript");
          break;
        case 1: // 稿件进度
          if (sessionStorage.getItem("token")) {
            this.$router.push({
              path: "/articleProgress",
              query: { fromHome: true },
            });
          } else {
            this.$router.push("/logins");
          }
          break;
        case 2: // 学术会议
          this.$router.push("/academicConference");
          break;
        case 3: // 教育培训
          this.$router.push({ path: "/educationalTraining" });
          break;
        case 4: // 图书商城
          this.$router.push("/bookMall");
          break;
        case 5: // 百家在线
          this.$router.push("/scholarOnline");
          break;
        case 6: // 百科在线
          this.$router.push("/periodicalOnline");
          break;
        case 7: // 推广界面
          this.$router.push("/extend/extend-market");
          break;
        case 8: // 专著出版
          window.open("https://app0xdykzjc4177.h5.xiaoeknow.com/p/decorate/page/eyJpZCI6IjQyMTExNTMifQ")
          break;
        case 9: // 行业报告
          this.$router.push("/industryReport");
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  padding: 10px 0;
  width: 100%;
  background-color: #222b35;
  text-align: center;

  .search-box {
    margin: 0 auto;
    width: 351px;
    height: 35px;
    line-height: 34px;
    background-color: #ffffff;
    border-radius: 18px;
    text-align: center;

    .search-icon {
      width: 15px;
      height: 15px;
      margin-right: 10px;
      vertical-align: middle;
    }

    span {
      font-size: 15px;
      color: rgba(0, 0, 0, 0.45);
      vertical-align: middle;
    }
  }
}

.promotion-swipe {
  margin: -96px auto 0;
  width: 351px;
  height: 120px;

  .van-swipe {
    height: 100%;
    border-radius: 8px;
  }
}

.column-box {
  display: flex;
  flex-wrap: wrap;
  margin: 12px auto;
  padding: 16px 5px 14px;
  width: 351px;
  background-color: #ffffff;
  border-radius: 8px;

  li {
    flex: 0 0 20%;
    text-align: center;

    img {
      width: 35px;
      height: 35px;
    }

    p {
      font-size: 12px;
      color: #333333;
    }

    &:nth-child(n+6) {
      margin-top: 15px;
    }
  }

}
</style>
